import React, { Component } from 'react';

export default class ConversationListItem extends Component {

  render() {
    const { otherUserImage, name, channel } = this.props.data;
    let { lastText } = this.props.data;
    if (lastText.length > 20) {
      lastText = lastText.substr(0, 20) + "...";
    }
    let selected = "";
    if (this.props.selected && this.props.selected.channel) {
      selected = this.props.selected.channel;
    }
    return (
      <div className={"conversation-list-item" + (selected === channel ? " selected" : "")} onClick={() => this.props.changeConversation(this.props.data)}>
        <img className="conversation-photo" src={otherUserImage} alt="conversation" />
        <div className="conversation-info">
          <h1 className="conversation-title">{ name }</h1>
          <p className="conversation-snippet">{ lastText }</p>
        </div>
      </div>
    );
  }
}